/**
 * Display chess-style countdown clock for a player.
 * Props:
 *  - seconds: number (remaining seconds)
 *  - active: boolean (is this player's turn?)
 *  - turnStartedAt: ISO string (server) — when active, the displayed time decreases.
 *  - label: string
 */
import { useEffect, useState } from "react";

function fmt(s) {
  const m = Math.floor(s / 60);
  const r = Math.max(0, Math.floor(s % 60));
  return `${String(m).padStart(2, "0")}:${String(r).padStart(2, "0")}`;
}

export default function Clock({ seconds, active, turnStartedAt, label, testid }) {
  const [tick, setTick] = useState(0);
  useEffect(() => {
    if (!active) return;
    const id = setInterval(() => setTick((t) => t + 1), 1000);
    return () => clearInterval(id);
  }, [active, turnStartedAt]);

  // Compute displayed seconds: if active, subtract elapsed since turnStartedAt
  let display = seconds;
  if (active && turnStartedAt) {
    const elapsed = (Date.now() - new Date(turnStartedAt).getTime()) / 1000;
    display = Math.max(0, seconds - elapsed);
  }
  const low = display < 30;

  return (
    <div
      data-testid={testid}
      className={`px-3 py-2 rounded-md border text-center min-w-[88px] ${
        active
          ? low
            ? "border-rose-500 bg-rose-500/10 text-rose-300 animate-pulse"
            : "border-[color:var(--primary)] bg-[color:var(--primary)]/10 text-[color:var(--primary)]"
          : "border-[color:var(--border)] text-[color:var(--text-secondary)]"
      }`}
      // Force re-render every tick when active
      key={`${active}-${tick}`}
    >
      <div className="text-[10px] tracking-[0.2em] mb-0.5">{label}</div>
      <div className="font-[Outfit] font-bold text-lg tabular-nums">{fmt(display)}</div>
    </div>
  );
}
